import { HttpError } from '@/lib/httpError'

export interface AuditLog {
  id: string
  timestamp: string
  layer: string
  service: string
  action: string
  category: string
  event_type: string
  outcome: string
  actor_id: string
  actor_account: string
  actor_role: string
  source_ip: string
  user_agent?: string
  target_type?: string
  target_id?: string
  target_name?: string
  message: string
  detail?: string
}

export interface ListAuditLogsResponse {
  logs: AuditLog[]
  total: number
  limit: number
  offset: number
}

export interface ListAuditLogsParams {
  layer?: string
  actor?: string
  action?: string
  category?: string
  outcome?: string
  service?: string
  q?: string
  from?: string
  to?: string
  limit?: number
  offset?: number
}

const BASE = '/api/v2/audit'

function toQuery(params: ListAuditLogsParams): URLSearchParams {
  const qs = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      qs.append(key, String(value))
    }
  })
  return qs
}

class AuditLogService {
  async listLogs(params: ListAuditLogsParams = {}): Promise<ListAuditLogsResponse> {
    const qs = toQuery(params)
    const response = await fetch(`${BASE}/logs${qs.toString() ? `?${qs}` : ''}`, {
      method: 'GET',
      credentials: 'include',
    })

    if (!response.ok) {
      switch (response.status) {
        case 400:
          throw new HttpError('errors.invalidFilter', 400)
        case 401:
          throw new HttpError('errors.unauthorized', 401)
        case 403:
          throw new HttpError('errors.forbidden', 403)
        case 500:
          throw new HttpError('errors.serverError', 500)
        default:
          throw new HttpError('errors.getLogsFailed', response.status)
      }
    }

    return response.json()
  }

  // A top-level navigation rather than a Blob: the endpoint already sets
  // Content-Disposition and the session cookie rides along.
  exportUrl(params: ListAuditLogsParams = {}): string {
    const qs = toQuery({ ...params, limit: undefined, offset: undefined })
    return `${BASE}/logs/export.csv${qs.toString() ? `?${qs}` : ''}`
  }
}

export const auditLogService = new AuditLogService()
